import React from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Table, 
  TableBody, 
  TableRow, 
  TableCell,
  TableHead,
  Box,
  List,
  ListItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const fullData = {
  "Managing": {
    payments: [
        {
          title: "Initial Payments",
          contents: [
            "Booking Amount: Equal to first month's rent (This will be adjusted to your first month's rent)",
            "Security Deposit with International/Local Guarantor: 1 month equivalent rent (Refundable after lease completion)",
            "Security Deposit without International/Local Guarantor: 2 month's equivalent rent (Refundable after lease completion)"
          ]
        },
        {
          title: "Regular Payments",
          contents: [
            "Monthly Rent: Payable in monthly installments"
          ]
        }
      ],
    terms: [
      { 
        title: 'BEDSPACE HOLD PERIOD',
        contents: [
          'The property/space you book will be on hold for 5 days from the receipt of initial payment. All monetary obligations must be fulfilled within the specified time period, in the absence of which any payments received will be forfeited resulting in the amount being non-refundable and non-redeemable.'
        ]
      },
      { 
        title: 'BOOKING CANCELLATION & REFUND POLICY',
        contents: [
          'Amount will be refunded only in the event of visa rejection, offer letter differ, medical issues, subsequent to submission of proof for the same. Any such rejections must be informed 15 working days before lease start date. If visa rejection is informed beyond the 15 days before limit, prorated rent will be deducted.',
          'The tenant has to request Autumn Rooms Technologies Pvt. Ltd. for a NOC after successful completion of the lease period or replacement, and mail it to the E-mail address supportireland@autumnrooms.com or submit the original of the same along with the refund claim form.',
          'Refund of the any amount is subject to the receipt of NOC only. It will be processed within 30 working days from the receipt of refund claim form or move out, whichever is later.'
        ]
      },
      { 
        title: 'TENANT REPLACEMENT',
        contents: [
          'If the tenant wish to move out of the property before the end of the lease period, the tenant must provide a replacement. Subjected to approval by Autumn Rooms'
        ]
      },
      { 
        title: 'LEASE AGREEMENT',
        contents: [
          'The tenancy start date is pre-determined for each property, and the rent shall fall due on the same regardless of when a tenant chooses to move in. If the tenant desires to move in before the pre-determined tenancy start date, they are required to pay a prorated rent. Early move-ins are subject to availability.',
          'This quotation is only for registration purposes. The lease agreement will be sent after the receipt of all payments and documents.',
          'The lease/service agreement must be signed and sent back within 24 hours of its receipt, without which your move-in to the property will be on hold.'
        ]
      }
    ]
  },
  "One-Time": {
    payments: [
        {
          title: "Initial Payments",
          contents: [
            "Booking Amount: Equal to first month's rent (This will be adjusted to your first month's rent)",
            "Security Deposit with International/Local Guarantor: 1 month equivalent rent (Guarantor requirement may vary by property)",
            "Security Deposit without International/Local Guarantor: 1 month equivalent rent (Refundable after lease completion)"
          ]
        },
        {
          title: "Additional Charges",
          contents: [
            "Monthly Rent: Payable in monthly installments",
            "Service Charge: 150 (CAD/GBP/EUR/AUD) "
          ]
        }
      ],
    terms: [
      { 
        title: 'BEDSPACE HOLD PERIOD',
        contents: [
          'The property/space you book will be on hold for 2 days from the receipt of initial payment. All monetary obligations must be fulfilled within the specified time period, in the absence of which any payments received will be forfeited resulting in the amount being non-refundable and non-redeemable.'
        ]
      },
      { 
        title: 'BOOKING CANCELLATION & REFUND POLICY',
        contents: [
          'Amount will be refunded only in the case if the booked property is unavailable.',
          'The tenant has to contact the landlord directly for the refund of any deposit and Autumn Rooms take no responsibility in the refund.'
        ]
      },
      { 
        title: 'TENANT REPLACEMENT',
        contents: [
          'If the tenant wish to move out of the property before the end of the lease period, the tenant must provide a replacement. Subjected to approval by Autumn Rooms'
        ]
      },
      { 
        title: 'LEASE AGREEMENT',
        contents: [
          'The tenancy start date is pre-determined for each property, and the rent shall fall due on the same regardless of when a tenant chooses to move in. If the tenant desires to move in before the pre-determined tenancy start date, they are required to pay a prorated rent. Early move-ins are subject to availability.',
          'This quotation is only for registration purposes. The lease agreement will be sent after the receipt of all payments and documents.',
          'The lease/service agreement must be signed and sent back within 24 hours of its receipt, without which your move-in to the property will be on hold.'
        ]
      },
      { 
        title: 'SERVICE CHARGES',
        contents: [
          'For all one-time properties, there will be an additional service charge payable to Autumn rooms 150  (AUD/CAD/GBP/EUR ) based on the each country. Autumn Rooms will not be offering any commissions, incentives etc to our partners for this bookings'
        ]
      },
      { 
        title: 'Property Management',
        contents: [
          'This property is not managed by Autumn Rooms and we donot take responsibility of property managemnet such as property maintainence, landlord and tenant management, deposit handling etc'
        ]
      }
    ]
  }
};

const PaymentTermsFull = ({ propertyType }) => {
  const data = fullData[propertyType];

  return (
    <Box sx={{ m: 2 }}>
      {/* <Typography variant="h5" gutterBottom>
        {propertyType === 'managed' ? 'Managed Properties' : 'One Time Properties'}
      </Typography> */}

<Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
  Payment Terms
</Typography>
<List sx={{ mb: 2, pl: 2 }}>
  {data.payments.map((section, index) => (
    <Accordion key={index} defaultExpanded sx={{ mb: 1.5, borderRadius: 2, overflow: 'hidden' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {section.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List sx={{ pl: 2 }}>
          {section.contents.map((content, idx) => (
            <ListItem
              key={idx}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                py: 0.5
              }}
            >
              <Typography 
                component="span" 
                sx={{ 
                  mr: 1, 
                  fontSize: '0.875rem', 
                  lineHeight: 1.8 
                }}
              >
                •
              </Typography>
              <Typography
                variant="body2"
                sx={{ 
                  whiteSpace: 'pre-wrap', 
                  fontSize: '0.875rem', 
                  lineHeight: 1.8 
                }}
              >
                {content}
              </Typography>
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  ))}
</List>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' ,mb:2}}>
        Terms & Conditions
        </Typography>
      {data.terms.map((term, index) => (
        <Accordion key={index} sx={{ mb: 1.5, ml:2 ,borderRadius: 2, overflow: 'hidden' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {term.title.charAt(0).toUpperCase() + term.title.slice(1).toLowerCase()}
            </Typography>
            </AccordionSummary>
          <AccordionDetails>
            <List sx={{ pl: 2 }}>
              {term.contents.map((content, idx) => (
                <ListItem
                  key={idx}
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    py: 0
                  }}
                >
                  <Typography 
                    component="span" 
                    sx={{ 
                      mr: 1, 
                      fontSize: '0.875rem', 
                      lineHeight: 1.8 
                    }}
                  >
                    •
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ 
                      whiteSpace: 'pre-wrap', 
                      fontSize: '0.875rem', 
                      lineHeight: 1.8 
                    }}
                  >
                    {content}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
                     <Box sx={{ pl: 2, display: 'flex', gap: 0.5, alignItems: 'center', fontSize: '0.75rem' }}>
                  <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                      Click here to read our complete{' '}
                      <Typography
                        component="a"
                        href="/refund-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: 'inline',
                          color: '#0000EE',
                          textDecoration: 'none',
                          '&:hover': { 
                            textDecoration: 'underline',
                            color: '#0000CC'
                          }
                        }}
                      >
                        refund policy
                      </Typography>
                      {' '}and{' '}
                      <Typography
                        component="a"
                        href="/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: 'inline',
                          color: '#0000EE',
                          textDecoration: 'none',
                          '&:hover': {
                            textDecoration: 'underline',
                            color: '#0000CC'
                          }
                        }}
                      >
                        terms and conditions
                      </Typography>
                      .
                    </Typography>
                  </Box>   
    </Box>
  );
};

export default PaymentTermsFull;